import React from 'react';

import { getUserIsValid } from 'effects/auth';

interface WrappedProps {
  readonly disabled?: boolean;
}
interface State {
  readonly userIsValid: boolean;
}

export const withAuthEnabled = <P extends object>( // eslint-disable-line
  WrappedComponent: React.ComponentType<P & WrappedProps>,
): React.ComponentType<P> => (
  class Wrapper extends React.Component<P & WrappedProps, State> {
    constructor(props: P & WrappedProps) {
      super(props);
      this.state = {
        userIsValid: false,
      };
    }

    componentDidMount = async (): Promise<void> => {
      this.setState({
        userIsValid: await getUserIsValid(),
      });
    };

    render = (): JSX.Element => {
      const { userIsValid } = this.state;
      const { disabled, ...rest } = this.props;
      const props = { ...rest, disabled: !userIsValid || disabled } as P & WrappedProps;
      /*
      createElement rather than JSX: Emotion's JSX namespace wraps LibraryManagedAttributes in
      a conditional type so it can add the css prop, and that conditional stays deferred while
      P is an unresolved generic, leaving no props object able to satisfy the attribute type.
      */
      return React.createElement(WrappedComponent, props);
    };
  }
);
